import { SmoothScroll } from '@garmin/support-utils';

export default (to) => {
  if (to.hash) {
    return SmoothScroll.scroll(`[id='${to.hash.split('#')[1]}']`);
  }

  return new Promise((resolve) => {
    if (to.matched.some((m) => m.meta?.scrollTo)) {
      setTimeout(() => {
        SmoothScroll.scroll(to.meta.scrollTo, 'top');
      }, 500);
      resolve();
    }

    resolve();
  });
};
